module.exports = __webpack_public_path__ + "media/St 4-game console-incorrect.4cf7df4f.wav";